import Swiper from "swiper";
require('./bootstrap');
import Alpine from 'alpinejs';
import './store/modal.js';
import './store/formValid.js';
import './store/validForm.js';
import './store/validFormCol.js';
import './store/news.js';
import './store/jobs.js';
import './store/message.js';
import './store/search.js';
import './export.js';
import intersect from '@alpinejs/intersect'
import AOS from 'aos';
window.Alpine = Alpine;
AOS.init();
import { Autoplay, Navigation } from "swiper/modules";
Alpine.plugin(intersect);
Alpine.prefix('data-');
Alpine.start();
window.addEventListener('load', () => {
    const element = document.querySelector('.fsp');
    if (element) {
        element.remove();
    }
});
document.addEventListener('DOMContentLoaded', function () {
    if (window.innerWidth > 1024) {
        let activeSection = null;

        function resetActiveSection() {
            if (activeSection) {
                const hideSection = activeSection.querySelector('.hide-section');
                activeSection.classList.remove(('active-s'))

                if (hideSection) {
                    hideSection.classList.remove('show');
                    hideSection.classList.add('hide');
                }
                activeSection.style.transform = 'translateY(0) translateX(0)';

                const section2 = document.querySelector('.missions-wrapper.app--tablet-hide .section:nth-of-type(2)');
                const section4 = document.querySelector('.missions-wrapper.app--tablet-hide .section:nth-of-type(4)');
                const section5 = document.querySelector('.missions-wrapper.app--tablet-hide .section:nth-of-type(5)');
                const section6 = document.querySelector('.missions-wrapper.app--tablet-hide .section:nth-of-type(6)');

                if (section2) section2.style.transform = 'translateX(0)';
                if (section4) section4.style.transform = 'translateX(0)';
                if (section5) section5.style.transform = 'translateY(0)';
                if (section6) section6.style.transform = 'translateY(0)';

                activeSection = null;
            }
        }

        function animateSection(section) {
            const hideSection = section.querySelector('.hide-section');
            if (!hideSection) return;

            const sectionIndex = Array.from(section.parentNode.children).indexOf(section) + 1;

            section.style.transition = 'all 0.5s ease-in-out';
            hideSection.style.transition = 'all 0.5s ease-in-out';

            hideSection.classList.remove('hide');
            hideSection.classList.add('show');

            switch (sectionIndex) {
                case 2:
                    const sec4 = document.querySelector('.missions-wrapper.app--tablet-hide .section:nth-of-type(4)');
                    if (sec4) sec4.style.transform = 'translateX(-100%)';
                    break;
                case 4:
                    section.style.transform = 'translateY(-100%)';
                    const sec2 = document.querySelector('.missions-wrapper.app--tablet-hide .section:nth-of-type(2)');
                    if (sec2) sec2.style.transform = 'translateX(-100%)';
                    break;
                case 5:
                    section.style.transform = 'translateY(-100%)';
                    break;
                case 6:
                    section.style.transform = 'translateY(-100%)';
                    const sec4b = document.querySelector('.missions-wrapper.app--tablet-hide .section:nth-of-type(4)');
                    if (sec4b) sec4b.style.transform = 'translateX(-100%)';
                    break;
            }

            activeSection = section;
        }

        document.querySelectorAll('.missions .section').forEach(section => {
            section.addEventListener('click', function () {
                if (activeSection === this) {
                    resetActiveSection();

                } else {
                    resetActiveSection();
                    animateSection(this);
                    activeSection.classList.add(('active-s'))

                }
            });
        });
    }
    if (window.innerWidth <= 1024) {
        const bannerMobEl = document.querySelector('.swiper-banner-mob');
        if (bannerMobEl) {
            var banner_swipermob = new Swiper(bannerMobEl, {
                autoplay: { delay: 3000 },
                speed: 800,
                loop: false,
                pagination: false,
                navigation: false,
            });

            setInterval(() => {
                if (banner_swipermob) {
                    if (banner_swipermob.activeIndex === banner_swipermob.slides.length - 1) {
                        banner_swipermob.slideTo(0);
                    } else {
                        banner_swipermob.slideNext();
                    }
                }
            }, 3000);
        }

        document.getElementById("myDropdown")?.addEventListener("click", function () {
            document.getElementById("dropdown-content")?.classList.toggle("show");
            document.getElementById("svg-cont-1")?.classList.toggle("rotate");
        });
        document.getElementById("myDropdown1")?.addEventListener("click", function () {
            document.getElementById("dropdown-content1")?.classList.toggle("show");
            document.getElementById("svg-cont-11")?.classList.toggle("rotate");
        });
        document.querySelectorAll('.missions .section').forEach(section => {
            section.addEventListener('click', function () {
                const hideSection = section.querySelector('.hide-section');
                if (!hideSection) return;

                if (hideSection.classList.contains('show')) {
                    section.classList.toggle('height-100');
                    hideSection.classList.remove('show');
                    hideSection.classList.add('hide');
                } else {
                    document.querySelectorAll('.hide-section').forEach(hide => {
                        hide.classList.remove('show');
                        hide.classList.add('hide');
                    });
                    hideSection.classList.remove('hide');
                    hideSection.classList.add('show');
                    section.classList.toggle('height-100');
                }
            });
        });
    }
    document.querySelectorAll("[data-toggle]").forEach((toggle) => {
        toggle.addEventListener("click", function () {
            let parent = this.closest(".nav-item");
            let isOpen = parent.classList.contains("open-mobile");
            document.querySelectorAll(".nav-item.open-mobile").forEach((el) => {
                el.classList.remove("open-mobile");
            });
            if (!isOpen) {
                parent.classList.add("open-mobile");
            }
        });
    });
    const bannerEl = document.querySelector('.swiper-banner');
    const plantSliderEl = document.querySelector(".plant-slider");
    if (bannerEl) {
        var banner_swiper = new Swiper(bannerEl, {
            modules: [Autoplay],
            speed: 800,
            loop: true,
            pagination: false,
            navigation: false,
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
            },
        });
    }
    if (plantSliderEl) {
        var swiper21 = new Swiper(plantSliderEl, {
            direction: "horizontal",
            slidesPerView: 1.2,
            spaceBetween: 20,
            loop: true,
            navigation: {
                nextEl: ".plant-slider-next",
                prevEl: ".plant-slider-prev",
            },
            breakpoints: {
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 23.67,
                }
            }
        });
        document.querySelector(".plant-slider-next")?.addEventListener("click", () => swiper21.slideNext());
        document.querySelector(".plant-slider-prev")?.addEventListener("click", () => swiper21.slidePrev());
    }
    if (document.querySelector(".files-wrapper")) {
       const fileSwiper = new Swiper(".files-wrapper", {
            slidesPerView: 2,
            spaceBetween: 20,
            loop: true,

            breakpoints: {
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 20,

                }
            },

        });

        document.querySelector(".files-slider-next")?.addEventListener("click", () => fileSwiper.slideNext());
        document.querySelector(".files-slider-prev")?.addEventListener("click", () => fileSwiper.slidePrev());
    }
    if (document.querySelector(".swiper-brands")) {
        new Swiper(".swiper-brands", {
            direction: "horizontal",
            slidesPerView: 1,
            spaceBetween: 20,
            loop: true,
            autoplay: { delay: 2000 },
        });
    }
    document.querySelectorAll('a[href^="#"]').forEach(link => {
        link.addEventListener('click', (event) => {
            event.preventDefault();
            const targetId = link.getAttribute('href').substring(1);
            const targetElement = document.getElementById(targetId);
            if (targetElement) {
                window.scrollTo({ top: targetElement.offsetTop - 120, behavior: 'smooth' });
            }
        });
    });
});


